import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    businessInterestTransfers: [],
  },
  mutations: {
    setBusinessInterestTransfers(state, businessInterestTransfers) {
      Vue.set(state, 'businessInterestTransfers', businessInterestTransfers);
    },
  },
  actions: {
    fetchBusinessInterestsTransferred({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/business-interests-transferred`).then(response => {
        return commit('setBusinessInterestTransfers', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};